import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ThisMonthEventsSection() {
  const [displayMonth, setDisplayMonth] = useState("");
  const [displayYear, setDisplayYear] = useState("");
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // API endpoint for calendar events
  const apiUrl = "/api/home/event-calendar";

  useEffect(() => {
    fetch(apiUrl)
      .then((r) => {
        if (!r.ok) throw new Error("Failed to fetch events");
        return r.json();
      })
      .then((data) => {
        if (!Array.isArray(data) || data.length === 0) {
          setEvents([]);
          setLoading(false);
          return;
        }
        // Get current month and year
        const now = new Date();
        const currentMonth = now.toLocaleString("en-US", { month: "short" });
        const currentYear = now.getFullYear();

        // Month order for sorting
        const monthOrder = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];

        const eventsWithIntYear = data.map(ev => ({
          ...ev,
          year: parseInt(ev.year)
        }));

        let thisMonthEvents = eventsWithIntYear.filter(
          ev => ev.month === currentMonth && ev.year === currentYear
        );

        let monthToShow = currentMonth;
        let yearToShow = currentYear;

        // If none, find the latest month with events
        if (thisMonthEvents.length === 0) {
          const sorted = [...eventsWithIntYear].sort((a, b) => {
            if (b.year !== a.year) return b.year - a.year;
            return monthOrder.indexOf(b.month) - monthOrder.indexOf(a.month);
          });
          if (sorted.length > 0) {
            monthToShow = sorted[0].month;
            yearToShow = sorted[0].year;
            thisMonthEvents = sorted.filter(
              ev => ev.month === monthToShow && ev.year === yearToShow
            );
          }
        }

        setDisplayMonth(monthToShow);
        setDisplayYear(yearToShow);
        setEvents(thisMonthEvents);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message || "Unknown error");
        setLoading(false);
      });
  }, [apiUrl]);

  // Scroll to top and navigate to /calendar
  const handleViewAll = () => {
    navigate("/calendar");
    setTimeout(() => window.scrollTo(0, 0), 0); // ensures scroll after navigation
  };

  if (loading) return null;
  if (error || !events.length) return null;

  return (
    <section id="this-month-events" className="parallax-section">
      <div className="container">
        <div className="row text-center">
          <div className="col-md-12 wow fadeInUp" data-wow-delay="0.4s">
            <h3>
              {displayMonth} {displayYear} Events
            </h3>
            <div className="table-responsive chart-no-select">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Venue</th>
                    <th>Discipline</th>
                    <th>Event Dates</th>
                    <th>Entry Dates</th>
                    <th>Status</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {events.map((ev, idx) => (
                    <tr key={idx}>
                      <td>{ev.venue}</td>
                      <td>{ev.discipline}</td>
                      <td>
                        {ev.eventStartDate ? ev.eventStartDate.split(" ")[0] : ""}{" "}
                        to{" "}
                        {ev.eventEndDate ? ev.eventEndDate.split(" ")[0] : ""}
                      </td>
                      <td>
                        {ev.entryOpenDate ? ev.entryOpenDate.split(" ")[0] : ""}{" "}
                        to{" "}
                        {ev.entryCloseDate ? ev.entryCloseDate.split(" ")[0] : ""}
                      </td>
                      <td>{ev.dtStatus}</td>
                      <td>
                        {ev.pathUrl && ev.remark ? (
                          <a href={ev.pathUrl} target="_blank" rel="noopener noreferrer">
                            {ev.remark}
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {events.length === 0 && (
                <p style={{ color: "#888" }}>No events in this month or previous months.</p>
              )}
            </div>
            <button
              className="btn btn-primary"
              style={{ marginTop: "15px", backgroundColor: "#222" }}
              onClick={handleViewAll}
            >
              View All
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
